import { SerializableObject } from '../../common-react/core';

import { ShipmentTrackingEvent } from './shipment-tracking-event.do';
import { Shipment } from './shipment.do';

export class TrackAndTrace extends SerializableObject {
  shipment: Shipment;
  trackingEvents: ShipmentTrackingEvent[];
  allPossibleTrackAndTraces: TrackAndTrace[];

  protected coercePropertyType(propertyName: string, propertyValue: unknown): unknown {
    const returnValue: unknown = super.coercePropertyType(propertyName, propertyValue);

    switch (propertyName) {
      case 'shipment':
        return new Shipment(propertyValue);
      case 'trackingEvents':
        return propertyValue instanceof Array ? propertyValue
          .map( (value) => {
            return new ShipmentTrackingEvent(value);
          }) : [];
      case 'allPossibleTrackAndTraces':
        return propertyValue instanceof Array ? propertyValue
          .map( (value) => {
            return new TrackAndTrace(value);
          }) : [];
      default:
        return returnValue;
    }
  }
}
